// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orcamentos_GetCategoriasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /orcamentos/getCategorias
 *
 * Returns list of servico categorias for orcamentos.
 */
import type { Orcamentos_GetCategoriasRow } from './Orcamentos_GetCategoriasRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orcamentos_GetCategoriasResponseDados = Orcamentos_GetCategoriasRow[];

export type Orcamentos_GetCategoriasResponse = ApiResponse<Orcamentos_GetCategoriasResponseDados>;

registerResponseContract('Orcamentos_GetCategoriasResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      servicoscategoria_id:                  { type: 'number',  required: true },
      servicoscategoria_nome:                { type: 'string',  required: true },
      servicoscategoria_prazo_retorno_dias:  { type: 'number',  required: true },
      servicoscategoria_prazo_garantia_dias: { type: 'number',  required: true },
      servicoscategoria_produtos_associados: { type: 'number',  required: true },
      nome:                                  { type: 'string',  required: true },
      prazo_retorno_dias:                    { type: 'number',  required: true },
      prazo_garantia_dias:                   { type: 'number',  required: true },
      produtos_associados:                   { type: 'number',  required: true },
      background_color:                      { type: 'string',  required: false },
    },
  },
})
